module.exports = __webpack_public_path__ + "img/2553fa6.jpg";